<template>
  <div>
    <el-card class="box-card">
      <el-row>
        <el-col :span="3"><div class="title">总评论数</div></el-col>
        <el-col :span="3"><div class="title">NWR</div></el-col>
        <el-col :span="3"><div class="title">指标趋势</div></el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div class="cir-num flex-cen-cen">
            <div class="cirnum">
              <div class="num">78</div>
              <div class="cir">环比：-12%</div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="cir-num flex-cen-cen">
            <div class="cirnum">
              <div class="num">43%</div>
            </div>
          </div>
        </el-col>
        <el-col :span="18"><div class="lineHist"><LineHistChart /></div></el-col>
      </el-row>
      <el-row>
        <el-col :span="24"><div class="s-title">消费者心声</div></el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="cloth-anlys">
            <div class="cloth-tab flex-cen-left">
              <div class="tab" :class="{'active' : tabType == 1}" @click="clothTab(1)">男装</div>
              <div class="tab" :class="{'active' : tabType == 2}" @click="clothTab(2)">女装</div>
            </div>
            <div class="title">内容分类分析——关注度和净推荐值</div>
            <div class="lineHist"><BuzzLineHistChart /></div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import LineHistChart from './components/LineHistChart'
import BuzzLineHistChart from './components/BuzzLineHisChart'
export default {
  components: { LineHistChart, BuzzLineHistChart },
  data() {
    return {
      queryInfo: {// pagination
        query: '',
        pagenum: 1,
        pagesize: 10,
      },
      currentPage: 1,// current page
      total: 0,// total
      rules: {},// rule
      form: {},// form
      loading: true,
      tabType: 1,// tab
    }
  },
  created() {
    
  },
  methods: {
    async getSel() {
      this.loading = true
      let { data } = await this.axiosApi('', {})
      this.loading = false
      console.log(data, 'data')
    },
    clothTab(e) {
      this.tabType = e
    },
  }
}
</script>

<style lang="scss" src="../assets/common.scss" scoped></style>
<style lang="scss" scoped>
.box-card{
  background-color: #F3F2F1;
  .title,.label-opt{
    margin-bottom: 2rem;
  }
  .title{
    background-color: #F8F7F6;
    text-align: center;
    border-radius: 0.5rem;
    padding: 0.5rem 0;
    margin-right: 1rem;
  }
  .cir-num{
    background-color: #F8F7F6;
    height: 10rem;
    margin-right: 1rem;
    .cirnum{
      .num,.cir{
        text-align: center;
      }
      .num{
        font-weight: bold;
        font-size: 22px;
        margin-bottom: 0.5rem;
      }
    }
  }
  .lineHist{
    background-color: #F8F7F6;
    padding: 0.5rem 0;
  }
  .s-title{
    background-color: #F8F7F6;
    width: 20rem;
    text-align: center;
    padding: 0.5rem;
    border-radius: 10px;
    margin: 1rem 0;
  }
  .cloth-anlys{
    background-color: #F7F6F6;
    .cloth-tab{
      .tab{
        width: 8rem;
        text-align: center;
        border: 2px solid #3B3C3C;
        margin-right: 0.5rem;
        border-radius: 10px;
        cursor: pointer;
      }
      .active{
        background-color: #FFFF24;
      }
    }
    .title{
      text-align: left;
      margin: 1rem 3rem;
    }
    .lineHist{
      margin: 0 2rem;
    }
  }
  .axis{
    margin-bottom: 1rem;
  }
  .label-opt{
    margin-right: 1rem;
    .label{
      margin-bottom: 0.5rem;
    }
    .sel-opt{
      width: 10rem;
    }
  }
  .eltable{
    >>>.el-table__header-wrapper{
      thead{
        tr{
          th{
            border-bottom: 2px solid #989ABC;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/voc/cmetanalys/index.vue